import React, { useEffect, useState } from "react";
import { Badge, Group, Button } from "@mantine/core";
import axios from "axios";
import { API } from "utiles/url";

const STATUSES = [
  { key: "ORDERED", label: "Ordered", color: "#FF6A00" },
  { key: "PAYMENT_FAILED", label: "Payment Failed", color: "#FF6A00" },
  { key: "CANCELED", label: "Cancelled", color: "#FF6A00" },
  { key: "READY_FOR_DELIVERY", label: "Ready for Delivery", color: "#FF6A00" },
  { key: "ON_DELIVERY", label: "On Delivery", color: "#FF6A00" },
  { key: "DELIVERED", label: "Delivered", color: "#FF6A00" },
];

export default function StatsGrid({
  onCardClick,
  handelSearch,
  clearFilter,
  selectedStatus,
}) {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchDeposit();
  }, []);

  const fetchDeposit = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("auth_token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const { data } = await axios.get(`${API}/order/status-counts`, config);
      if (data) {
        setLoading(false);
        setData(data);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error);
    }
  };

  const handleOnClick = (status) => {
    onCardClick(status);
    handelSearch(null);
  };

  const getButtonStyles = (status) => ({
    root: {
      fontWeight: 600,
      backgroundColor: selectedStatus === status ? "#FF6A00" : "transparent",
      color: selectedStatus === status ? "white" : "rgb(20, 61, 89)",
      border: `1px solid ${selectedStatus === status ? "#FF6A00" : "#ddd"}`,
      padding: "8px 12px",
      minWidth: "100px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      transition: "all 0.2s ease",
      "&:hover": {
        color: "#FFFFFF",
        backgroundColor: "#FF6A00",
      },
    },
  });

  const getBadgeStyles = (status, color) => ({
    backgroundColor: selectedStatus === status ? "white" : color,
    color: selectedStatus === status ? "#FF6A00" : "white",
    marginLeft: 8,
  });

  return (
    <Group spacing="xs" position="left" style={{ paddingBottom: 16 }}>
      {STATUSES.map(({ key, label, color }) => (
        <Button
          key={key}
          onClick={() => handleOnClick(key)}
          radius="md"
          styles={getButtonStyles(key)}
        >
          {label}
          <Badge size="xs" style={getBadgeStyles(key, color)}>
            {data?.[key] > 0 ? data[key] : 0}
          </Badge>
        </Button>
      ))}
      <Button
        onClick={clearFilter}
        radius="md"
        styles={{
          root: {
            fontWeight: "bold",
            backgroundColor: "#808080",
            padding: "8px 12px",
            minWidth: "60px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          },
        }}
      >
        All
      </Button>
    </Group>
  );
}